import { render, staticRenderFns } from "./GateWayView.vue?vue&type=template&id=51da22f4&scoped=true"
import script from "./GateWayView.vue?vue&type=script&lang=js"
export * from "./GateWayView.vue?vue&type=script&lang=js"
import style0 from "./GateWayView.vue?vue&type=style&index=0&id=51da22f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da22f4",
  null
  
)

export default component.exports